import { render } from "./TherapeuticExercises.vue?vue&type=template&id=829516c2&scoped=true"
import script from "./TherapeuticExercises.vue?vue&type=script&lang=js"
export * from "./TherapeuticExercises.vue?vue&type=script&lang=js"

import "./TherapeuticExercises.vue?vue&type=style&index=0&id=829516c2&scoped=true&lang=css"

import exportComponent from "/home/angelkiro/Dev/SVPhysio/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-829516c2"]])

export default __exports__